import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { msalInstance } from "./authConfig";
import { MsalProvider } from "@azure/msal-react";

async function init() {
  try {
    // Process redirect response (if any)
    await msalInstance.handleRedirectPromise();
  } catch (e) {
    console.error("🔁 MSAL handleRedirect error:", e);
  }

  // Then mount the app
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}

init();
